import {c, color, theme, is_mobile} from './modules/settings.js';

(function ($) {
	$(function () {

	});
})(jQuery);